<template>
    <div>
        <el-row style="margin-top: 2vh; padding: 20px;">
            <!-- 搜索表单区域 -->
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="食材名称">
                        <el-input v-model="searchForm.materialName" placeholder="请输入食材名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <!-- 修改：点击查询按钮触发前端过滤 -->
                        <el-button type="primary" icon="el-icon-search" @click="filterMaterialList()">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格区域 -->
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="materialList" height="65vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="materialName" label="食材名称" align="center" />
                    <el-table-column prop="num" label="所需数量" align="center"></el-table-column>
                    <el-table-column prop="unit" label="单位" align="center" />
                    <el-table-column prop="unitPrice" label="单价" align="center" />
                    <el-table-column label="图片" align="center" width="220">
                        <template #default="scope">
                            <el-image v-if="scope.row.photo" :src="scope.row.photo" fit="cover"
                                style="width: 80px; height: 60px; border-radius: 4px;"
                                :preview-src-list="[scope.row.photo]" placeholder="加载中..." />
                            <span v-else class="text-gray-400">暂无图片</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="280">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="showQuoteDialog(scope.row)">
                                报价
                            </el-button>
                            <el-button v-if="roleId !== 4" type="success" size="small"
                                @click="showQuoteDrawer(scope.row)">
                                查看报价
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页区域 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                </div>
            </el-col>
        </el-row>

        <!-- 供应商报价弹窗 -->
        <el-dialog title="食材报价提交" :visible.sync="quoteDialogVisible" width="650px"
            :before-close="handleQuoteDialogClose" :z-index="2100" append-to-body modal-append-to-body>
            <el-form :model="quoteForm" :rules="quoteRules" ref="quoteRef" label-width="130px" class="mt-2">
                <!-- 食材基础信息（只读） -->
                <el-form-item label="食材名称">
                    <el-input v-model="quoteForm.materialName" disabled class="bg-gray-50" />
                </el-form-item>

                <el-form-item label="图片" prop="specImg">
                    <!-- 原有图片预览（仅展示，不上传） -->
                    <div v-if="quoteForm.originalSpecImg && !quoteForm.specImgFile" class="mb-2">
                        <el-image :src="quoteForm.originalSpecImg" fit="cover"
                            style="width: 120px; height: 90px; border-radius: 4px;"
                            :preview-src-list="[quoteForm.originalSpecImg]" />
                        <div class="text-gray-500 text-xs mt-1">注：如需更新图片请重新上传</div>
                    </div>
                    <!-- 新上传图片预览 -->
                    <div v-if="quoteForm.specImgFile" class="mb-2">
                        <el-image :src="quoteForm.specImgUrl" fit="cover"
                            style="width: 120px; height: 90px; border-radius: 4px;"
                            :preview-src-list="[quoteForm.specImgUrl]" />
                    </div>
                    <!-- 文件上传组件（自定义上传，不自动提交） -->
                    <el-upload class="upload-demo" :action="''" :auto-upload="false" :http-request="handleSpecImgUpload"
                        :on-change="handleFileChange" :on-remove="handleFileRemove" :file-list="specImgFileList"
                        accept="image/*" :limit="1" list-type="picture-card">
                        <i class="el-icon-plus"></i>
                        <div class="el-upload__text">点击上传图片</div>
                    </el-upload>
                    <div class="el-upload__tip text-gray-500 mt-1">
                        支持jpg/png格式，大小不超过2MB
                    </div>
                </el-form-item>

                <el-form-item label="单价(元)" prop="price">
                    <el-input v-model="quoteForm.price" placeholder="请输入单价（保留2位小数）" @input="calcTotalPrice" />
                </el-form-item>
                <el-form-item label="规格" prop="specifications">
                    <el-input v-model="quoteForm.specifications" placeholder="请输入规格" />
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="quoteForm.remark" placeholder="请输入备注" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="quoteDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitQuote()" :loading="submitLoading">提交报价</el-button>
            </div>
        </el-dialog>

        <!-- 查看报价抽屉弹窗 -->
        <el-drawer title="食材报价列表" :visible.sync="quoteDrawerVisible" direction="rtl" size="70%" :z-index="3200"
            append-to-body modal-append-to-body @close="handleQuoteDrawerClose">
            <div class="quote-drawer-content">
                <!-- 抽屉内搜索 -->
                <el-form :inline="true" :model="quoteSearchForm" class="mb-4">
                    <el-form-item label="供应商名称">
                        <el-input v-model="quoteSearchForm.supplier" placeholder="请输入供应商名称" clearable></el-input>
                    </el-form-item>

                    <el-form-item>
                        <!-- 修改：点击查询按钮触发报价列表前端过滤 -->
                        <el-button type="primary" @click="filterQuoteList()">查询</el-button>
                        <el-button @click="resetQuoteSearch()">重置</el-button>
                    </el-form-item>
                </el-form>

                <!-- 报价列表表格 -->
                <el-table :data="quoteList" border style="width: 100%;" :loading="quoteListLoading"
                    :header-cell-class-name="'table-header'">
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="supplier" label="供应商名称" align="center" />
                    <el-table-column prop="price" label="报价单价(元)" align="center">
                    </el-table-column>
                    <el-table-column prop="phone" label="联系方式" align="center" />
                    <el-table-column prop="specifications" label="规格" align="center" />
                    <el-table-column label="图片" align="center" width="120">
                        <template #default="scope">
                            <el-image v-if="scope.row.photo" :src="scope.row.photo" fit="cover"
                                style="width: 80px; height: 60px; border-radius: 4px;"
                                :preview-src-list="[scope.row.photo]" placeholder="加载中..." />
                            <span v-else class="text-gray-400">暂无图片</span>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 抽屉内分页 -->
                <div style="margin-top: 20px; text-align: center;">
                    <el-pagination @size-change="handleQuoteSizeChange" @current-change="handleQuoteCurrentChange"
                        :current-page="quoteCurrentPage" :page-sizes="[10, 20, 50]" :page-size="quotePageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="quoteTotalCount"></el-pagination>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { getBiddingMaterials, supplierBidding, getBiddingByPid } from "@/api/quotation";
import { Message } from 'element-ui';

export default {
    name: "StockMaterialManage",
    data() {
        return {
            roleId: '',
            searchForm: { materialName: "", materialType: "", stockStatus: "" },
            materialList: [],
            // 新增：缓存全量食材数据
            allMaterialList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            dialogVisible: false,
            recordDialogVisible: false,
            quoteDialogVisible: false,
            submitLoading: false, // 提交加载状态

            // 查看报价抽屉相关
            quoteDrawerVisible: false,
            currentMaterialId: "", // 当前查看报价的食材ID
            quoteList: [],
            // 新增：缓存全量报价数据
            allQuoteList: [],
            quoteListLoading: false, // 报价列表加载状态
            quoteSearchForm: { // 报价列表搜索条件
                supplier: "", // 修正：原字段名是supplier，不是supplierName
                status: ""
            },
            quoteCurrentPage: 1, // 报价列表当前页
            quotePageSize: 10, // 报价列表页大小
            quoteTotalCount: 0, // 报价列表总条数

            // 食材表单数据
            form: {
                id: "",
                materialCode: "",
                materialName: "",
                materialType: "",
                specImg: "",  // 替换原spec为规格图片地址
                unit: "",
                stockNum: 0,
                minStock: 0,
                stockStatus: "normal",
                updateTime: "",
                remark: "",
            },
            formRules: {
                materialName: [{ required: true, message: "请输入食材名称", trigger: "blur" }],
                materialType: [{ required: true, message: "请选择食材类别", trigger: "blur" }],
                specImg: [{ required: true, message: "请上传规格图片", trigger: "change" }],
                unit: [{ required: true, message: "请输入计量单位", trigger: "blur" }],
                minStock: [
                    { required: true, message: "请输入最低库存", trigger: "blur" },
                    { type: "number", min: 1, message: "最低库存不能小于1", trigger: "blur" },
                ],
            },

            // 报价表单数据
            quoteForm: {
                materialId: "",
                materialCode: "",
                materialName: "",
                originalSpecImg: "", // 原有图片地址（仅展示）
                specImgFile: null,   // 上传的文件对象
                specImgUrl: "",      // 上传文件的预览地址
                unit: "",
                requireNum: 0,
                supplier: "",
                qualification: "",
                price: 0,
                totalPrice: 0,  // 总价
                remark: "",
            },
            // 规格图片上传文件列表
            specImgFileList: [],
            // 报价表单验证规则
            quoteRules: {
                supplier: [{ required: true, message: "请输入供应商名称", trigger: "blur" }],
                specImg: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (this.quoteForm.specImgFile || this.quoteForm.originalSpecImg) {
                                callback();
                            } else {
                                callback(new Error('请上传规格图片'));
                            }
                        },
                        trigger: "change"
                    }
                ],
                price: [{ required: true, message: "请输入报价单价", trigger: "blur" }],
                specifications: [{ required: true, message: "请输入规格", trigger: "blur" }]
            },

            stockRecordList: [],
        };
    },
    mounted() {
        this.getMaterialList();
        // 初始化报价有效期默认值（当前日期+7天）
        const defaultExpiry = new Date();
        defaultExpiry.setDate(defaultExpiry.getDate() + 7);
        this.roleId = localStorage.getItem('roleId')
    },
    methods: {
        /**
         * 获取食材列表
         */
        getMaterialList() {
            getBiddingMaterials({
                userId: localStorage.getItem('userId')
            })
                .then((response) => {
                    // 修改：缓存全量数据
                    this.allMaterialList = response.data || [];
                    // 初始化时执行过滤（显示全部数据）
                    this.filterMaterialList();
                    this.totalCount = response.total || response.data.length;
                })
                .catch(error => {
                    console.error('获取食材列表失败:', error);
                    this.$message.error('获取食材列表失败，请重试');
                    this.allMaterialList = [];
                    this.materialList = [];
                    this.totalCount = 0;
                });
        },

        /**
         * 前端过滤食材列表
         */
        filterMaterialList() {
            let filteredData = [...this.allMaterialList];

            // 按食材名称过滤（模糊匹配，忽略大小写）
            if (this.searchForm.materialName) {
                const keyword = this.searchForm.materialName.trim().toLowerCase();
                filteredData = filteredData.filter(item =>
                    item.materialName && item.materialName.toLowerCase().includes(keyword)
                );
            }

            // 如果需要扩展其他过滤条件（如食材类型、库存状态），可以在这里添加
            // if (this.searchForm.materialType) {
            //     filteredData = filteredData.filter(item => item.materialType === this.searchForm.materialType);
            // }

            // 更新总条数
            this.totalCount = filteredData.length;

            // 分页处理
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.materialList = filteredData.slice(start, end);
        },

        /**
         * 重置搜索条件
         */
        resetSearch() {
            this.searchForm = { materialName: "", materialType: "", stockStatus: "" };
            this.currentPage = 1;
            // 修改：调用前端过滤，恢复显示全部数据
            this.filterMaterialList();
        },

        /**
         * 分页大小改变
         */
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            // 修改：分页变化时重新过滤
            this.filterMaterialList();
        },

        /**
         * 当前页码改变
         */
        handleCurrentChange(val) {
            this.currentPage = val;
            // 修改：页码变化时重新过滤
            this.filterMaterialList();
        },

        /**
         * 关闭编辑弹窗
         */
        handleDialogClose() {
            this.dialogVisible = false;
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        /**
         * 提交编辑表单
         */
        submitForm() {
            this.$refs.formRef.validate((isValid) => {
                if (isValid) {
                    this.form.updateTime = new Date().toLocaleString("zh-CN", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                    }).replace(/\//g, "-");
                    this.form.stockStatus =
                        this.form.stockNum <= 0
                            ? "out"
                            : this.form.stockNum <= this.form.minStock
                                ? "low"
                                : "normal";

                    this.dialogVisible = false;
                    this.$message.success(this.form.id ? "编辑成功" : "新增成功");
                    this.getMaterialList();
                }
            });
        },

        /**
         * 打开报价弹窗
         */
        showQuoteDialog(row) {
            console.log(row);

            this.quoteDialogVisible = true;
            this.specImgFileList = [];
            this.quoteForm = {
                materialId: row.id,
                materialCode: row.materialCode,
                materialName: row.materialName,
                originalSpecImg: row.specImg || "",
                specImgFile: null,
                specImgUrl: "",
                unit: row.unit,
                price: 0,
                totalPrice: 0,
                remark: "",
            };
            this.$nextTick(() => {
                this.$refs.quoteRef?.clearValidate();
            });
        },

        /**
         * 关闭报价弹窗
         */
        handleQuoteDialogClose() {
            this.quoteDialogVisible = false;
            this.specImgFileList = [];
            this.quoteForm.specImgFile = null;
            this.quoteForm.specImgUrl = "";
            this.$nextTick(() => {
                this.$refs.quoteRef?.clearValidate();
            });
        },

        /**
         * 图片文件选择变化
         */
        handleFileChange(file, fileList) {
            this.specImgFileList = fileList.slice(-1);

            if (file.raw) {
                const isImage = file.raw.type.startsWith('image/');
                const isLt2M = file.raw.size / 1024 / 1024 < 2;

                if (!isImage) {
                    Message.error('请上传图片格式文件！');
                    this.specImgFileList = [];
                    this.quoteForm.specImgFile = null;
                    this.quoteForm.specImgUrl = "";
                    return;
                }

                if (!isLt2M) {
                    Message.error('规格图片大小不能超过2MB！');
                    this.specImgFileList = [];
                    this.quoteForm.specImgFile = null;
                    this.quoteForm.specImgUrl = "";
                    return;
                }

                this.quoteForm.specImgFile = file.raw;
                const reader = new FileReader();
                reader.readAsDataURL(file.raw);
                reader.onload = (e) => {
                    this.quoteForm.specImgUrl = e.target.result;
                };
            }
        },

        /**
         * 移除上传文件
         */
        handleFileRemove() {
            this.specImgFileList = [];
            this.quoteForm.specImgFile = null;
            this.quoteForm.specImgUrl = "";
        },

        /**
         * 自定义图片上传方法
         */
        handleSpecImgUpload() {
            // 空方法，文件在提交报价时统一上传
        },

        /**
         * 计算总价
         */
        calcTotalPrice() {
            if (this.quoteForm.price && this.quoteForm.requireNum) {
                this.quoteForm.totalPrice = (this.quoteForm.price * this.quoteForm.requireNum).toFixed(2);
            } else {
                this.quoteForm.totalPrice = 0;
            }
        },

        /**
         * 提交报价
         */
        submitQuote() {
            this.$refs.quoteRef.validate(async (isValid) => {
                if (isValid) {
                    this.submitLoading = true;
                    try {
                        const formData = new FormData();
                        formData.append('pid', this.quoteForm.materialId);
                        formData.append('price', this.quoteForm.price);
                        formData.append('specifications', this.quoteForm.specifications);
                        formData.append('remark', this.quoteForm.remark || '');
                        formData.append('supplierId', localStorage.getItem('userId'));

                        if (this.quoteForm.specImgFile) {
                            formData.append('file', this.quoteForm.specImgFile);
                        }

                        const response = await supplierBidding(formData);

                        if (response.code === 200 || response.success) {
                            Message.success(response.message || "报价提交成功！等待审核");
                            this.quoteDialogVisible = false;
                            this.specImgFileList = [];
                            this.quoteForm.specImgFile = null;
                            this.quoteForm.specImgUrl = "";
                            this.getMaterialList();
                        } else {
                            Message.error(response.message || "报价提交失败");
                        }
                    } catch (error) {
                        console.error("报价提交失败:", error);
                        Message.error("网络错误，报价提交失败，请重试");
                    } finally {
                        this.submitLoading = false;
                    }
                }
            });
        },

        /**
         * 格式化食材类别显示
         */
        formatType(type) {
            const typeMap = {
                vegetable: "蔬菜类",
                meat: "肉类",
                seafood: "水产类",
                grainOil: "粮油类",
                driedGoods: "干货类",
            };
            return typeMap[type] || type;
        },

        /**
         * 表格行点击选中
         */
        handleRowClick(row) {
            this.$refs.tableRef?.toggleRowSelection(row);
        },

        /**
         * 打开查看报价抽屉
         */
        showQuoteDrawer(row) {
            this.quoteDrawerVisible = true;
            this.currentMaterialId = row.id;
            this.quoteCurrentPage = 1;
            this.resetQuoteSearch(); // 重置搜索条件
            this.getQuoteList(); // 获取报价列表
        },

        /**
         * 关闭查看报价抽屉
         */
        handleQuoteDrawerClose() {
            this.quoteDrawerVisible = false;
            this.quoteList = [];
            this.allQuoteList = []; // 清空缓存
            this.currentMaterialId = "";
        },

        /**
         * 获取报价列表数据
         */
        getQuoteList() {
            this.quoteListLoading = true;

            // 构造请求参数
            const params = {
                pid: this.currentMaterialId,
            };

            // 调用获取报价列表接口
            getBiddingByPid(params)
                .then((response) => {
                    // 修改：缓存全量报价数据
                    this.allQuoteList = response.data || [];
                    // 初始化时执行报价列表过滤
                    this.filterQuoteList();
                    this.quoteTotalCount = response.data.length;
                })
                .catch(error => {
                    console.error('获取报价列表失败:', error);
                    this.$message.error('获取报价列表失败，请重试');
                    this.allQuoteList = [];
                    this.quoteList = [];
                    this.quoteTotalCount = 0;
                })
                .finally(() => {
                    this.quoteListLoading = false;
                });
        },

        /**
         * 前端过滤报价列表
         */
        filterQuoteList() {
            let filteredData = [...this.allQuoteList];

            // 按供应商名称过滤（模糊匹配，忽略大小写）
            if (this.quoteSearchForm.supplier) {
                const keyword = this.quoteSearchForm.supplier.trim().toLowerCase();
                filteredData = filteredData.filter(item =>
                    item.supplier && item.supplier.toLowerCase().includes(keyword)
                );
            }

            // 更新报价列表总条数
            this.quoteTotalCount = filteredData.length;

            // 分页处理
            const start = (this.quoteCurrentPage - 1) * this.quotePageSize;
            const end = start + this.quotePageSize;
            this.quoteList = filteredData.slice(start, end);
        },

        /**
         * 重置报价搜索条件
         */
        resetQuoteSearch() {
            this.quoteSearchForm = {
                supplier: "",
                status: ""
            };
            this.quoteCurrentPage = 1;
            // 调用报价列表过滤，恢复显示全部数据
            this.filterQuoteList();
        },

        /**
         * 报价列表分页大小改变
         */
        handleQuoteSizeChange(val) {
            this.quotePageSize = val;
            this.quoteCurrentPage = 1;
            this.filterQuoteList();
        },

        /**
         * 报价列表当前页码改变
         */
        handleQuoteCurrentChange(val) {
            this.quoteCurrentPage = val;
            this.filterQuoteList();
        }
    },
};
</script>

<style lang="scss" scoped>
.table-header {
    background-color: rgb(230, 242, 255) !important;
    font-weight: bold;
}

.text-red-500 {
    color: #f56c6c;
}

.font-bold {
    font-weight: bold;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
}

.el-form-item {
    margin-bottom: 20px;
}

/* 只读输入框样式 */
::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa !important;
    color: #606266 !important;
}

/* 弹窗层级控制 */
::v-deep .el-dialog__wrapper {
    z-index: inherit !important;
}

/* 上传组件样式优化 */
::v-deep .el-upload--picture-card {
    width: 120px;
    height: 90px;
    line-height: 90px;
}

/* 抽屉样式优化 */
.quote-drawer-content {
    padding: 0 10px;
    height: calc(100vh - 120px);
    overflow: auto;
}

.mb-2 {
    margin-bottom: 8px;
}

.mb-4 {
    margin-bottom: 16px;
}

.mt-1 {
    margin-top: 4px;
}

.text-gray-500 {
    color: #909399;
    font-size: 12px;
}

.text-gray-400 {
    color: #c0c4cc;
}

.text-xs {
    font-size: 11px;
}
</style>